import React from "react";
import classes from "./MainFoooterAbout.module.css";
import { ImFacebook } from "react-icons/im";
import logo from "../../Assets/logo.png";

const MainFoooterAbout = () => {
  return (
    <div className={classes["main-footer__about-container"]}>
      <div>
        <span className={classes["about-container__icon-container"]}>
          <img src={logo} alt="logo" /> <p>B and B Company</p>
        </span>
        <p>
          We are a noted manufacturer and supplier of 9am food products. A wide
          array of food products like sauce, combo sauce, synthetic vinegar,
          mayonnaise, tomato puree, pickles, noodles, sharbat, and jam.
        </p>
      </div>
      <div className={classes["main-footer__icons-container"]}>
        <a
          href="https://www.facebook.com/bandbpvc"
          target="_blank"
          className={classes["blue__icon"]}
          rel="noreferrer"
        >
          <ImFacebook />
        </a>

        <a
          href="https://www.facebook.com/B-and-B-International-Trading-103369258061457"
          target="_blank"
          className={classes["red__icon"]}
          rel="noreferrer"
        >
          <ImFacebook />
        </a>
      </div>
    </div>
  );
};

export default MainFoooterAbout;
